<template lang="pug">
  div
    div( v-if="isUnsupportedNetwork(audit.network)" )
      span( class="badge badge-secondary mb-1" ) Unsupported Network

    div( v-else class="d-flex" v-bind:class="{ 'flex-column': column, 'flex-wrap': wrap, 'align-items-center': center }" )
      span( v-if="audit.proxyDetails" class="badge badge-secondary mb-1" )
        span( v-if="audit.proxyDetails.isResidential" ) Proxy: {{ audit.proxyDetails.country }}
        span( v-else-if="audit.proxyDetails.moonpullLabel" ) DC: {{ audit.proxyDetails.moonpullLabel }}
        span( v-else ) Country: {{ audit.proxyDetails.country }}
      
      span(
        class="badge badge-secondary mb-1"
        v-if="$moonpull.currentUserIsSuperAdmin() && audit.webUnlockerRequestId"
      )
        MMoonpullIcon( class="mr-1" )
        span( class="fa fa-unlock" )
        |  Lite Used
      
      span(
        class="badge badge-danger mb-1"
        v-if="$moonpull.currentUserIsSuperAdmin() && audit.liteResult && audit.liteResult.error"
      )
        MModalButton(
          button-classes=""
          modal-size="modal-xl"
        )
          span( slot="button-inner" class="text-white" )
            MMoonpullIcon( class="mr-1" )
            span( class="fa fa-unlock mr-1" )
            | Lite Error
          
          div( slot="body" class="text-left" )
            pre {{ audit.liteResult.error.stack }}
      
      span( v-if="! audit.useDataCentre && audit.proxyDetails && audit.proxyDetails.country === 'GB' && $moonpull.currentUserIsSuperAdmin()" class="badge badge-secondary mb-1" )
        MMoonpullIcon
        | &nbsp;AWS

      template( v-if="audit.advertiserSnapshot" )
        span( class="badge badge-warning mb-1" v-if="audit.advertiserSnapshot.trackingMethodNarrative" ) {{ audit.advertiserSnapshot.trackingMethodNarrative }}
        
        span( class="badge badge-secondary mb-1" v-if="! audit.csvOverrideCookieType && audit.advertiserSnapshot.bespokeCookieValueType && audit.advertiserSnapshot.bespokeCookieValueType !== 2" )
          MCookieIcon
          | &nbsp; {{ audit.advertiserSnapshot.bespokeCookieValueType }}: {{ audit.advertiserSnapshot.bespokeCookieName }} {{ audit.advertiserSnapshot.bespokeCookieValueType === 4 && audit.advertiserSnapshot.bespokeCookieValue ? `= ${audit.advertiserSnapshot.bespokeCookieValue}` : '' }}

      span( class="badge badge-secondary mb-1" v-if="audit.csvOverrideCookieType && Number(audit.csvOverrideCookieType) !== 2" )
        MCookieIcon
        | &nbsp; (User) {{ audit.csvOverrideCookieType }}: {{ audit.csvOverrideCookieName }} {{ Number(audit.csvOverrideCookieType) === 4 && audit.csvOverrideCookieValue ? `= ${audit.csvOverrideCookieValue}` : '' }}
      
      span( class="badge badge-secondary mb-1" v-if="audit.csvOverrideAni" )
        | (User) Custom ANI: {{ audit.csvOverrideAni }}
      span( class="badge badge-secondary mb-1" v-else-if="audit.advertiserSnapshot && audit.advertiserSnapshot.bespokeAni" )
        | Custom ANI: {{ audit.advertiserSnapshot.bespokeAni }}
      
      span( class="badge badge-secondary mb-1" v-if="audit.csvOverrideMasterTag" )
        | &nbsp;(User) Custom Tag: .*{{ audit.csvOverrideMasterTag }}.*
      span( class="badge badge-secondary mb-1" v-else-if="audit.advertiserSnapshot && audit.advertiserSnapshot.bespokeMasterTag" )
          | &nbsp;Custom Tag: {{ audit.advertiserSnapshot.bespokeMasterTag }}

      span( class="badge badge-secondary mb-1" v-if="audit.proxy && audit.proxy !== 'none'" ) Proxy: {{ audit.proxy.toUpperCase() }}
      span( class="badge badge-secondary mb-1" v-if="$moonpull.currentUserIsSuperAdmin() && audit.isRetry" )
        MMoonpullIcon
        | &nbsp;Auto residential retry

      span( class="badge badge-secondary mb-1" v-if="$moonpull.auditHasError(audit, '10.2.1')" ) Shopify detected
      
      template( v-if="audit.manualReviewRequired" )
        span( class="badge badge-secondary mb-1" v-if="audit.inferredS2S" ) Header cookie containing ANI
        
      span( class="badge badge-secondary mb-1" v-if="audit.interstitialNavigated" ) Interstitial Navigated
      span( class="badge badge-secondary mb-1" v-if="$moonpull.currentUserIsSuperAdmin() && audit.aniTruncated" )
        MMoonpullIcon
        | &nbsp; ANI trunc.

      template( v-if="audit.detectedCmp" )
        span( class="badge badge-info mb-1" )
          | CMP: {{ audit.detectedCmp.name }}

      template( v-if="audit.cmpVendor || (audit.liteResult && audit.liteResult.cmp)" )
        span( class="badge badge-info mb-1" )
          | CMP: {{ audit.cmpVendor || (audit.liteResult && audit.liteResult.cmp) }}
      
      span( class="badge badge-secondary mb-1" v-if="audit.moonpullErrors && audit.moonpullErrors.find(m => [ '5.3.1', '6.3.1', '7.3.1' ].includes(m.moonpullErrorId))" )
        | Non-matched Tag

      span( class="badge badge-secondary mb-1" v-if="$moonpull.currentUserIsSuperAdmin() && !! audit.moonpullErrors && audit.moonpullErrors.find(m => m.moonpullErrorId === '10.1.1')" )
        MMoonpullIcon
        | &nbsp; Recaptcha

      template( v-if="!! audit.batchLink" )
        span( class="badge badge-secondary mb-1" v-if="!! audit.batchLink.postAlpURL" )
          | &nbsp; Alternative 'Refresh stage' URL.
        span( class="badge badge-secondary mb-1" v-if="!! audit.batchLink.skipConsent" )
          | &nbsp; Consent skipped
        
        span( class="badge badge-secondary mb-1" v-if="$moonpull.currentUserIsSuperAdmin() && !! audit.batchLink.puppeteerFlags" )
          MMoonpullIcon
          | 🚩 {{ audit.batchLink.puppeteerFlags.split(';;').join(', ') }}

      span(
        class="badge badge-secondary mb-1"
        v-if="shouldShowGRReasonBadge"
      )
        MMoonpullIcon( class="mr-2" v-if="! audit.injectedResult" )
        | GR: {{ audit.advertiserSnapshot.cannotAuditReason }}

      span( class="badge badge-secondary mb-1" v-if="audit.advertiser && audit.advertiser.whitelistRequest && audit.advertiser.whitelistRequest.whitelistActive" )
        | Whitelist Confirmed
      span( class="badge badge-secondary mb-1" v-else-if="audit.advertiser && audit.advertiser.whitelistRequest && ! audit.advertiser.whitelistRequest.whitelistSent" )
        | Whitelist Requested

      template( v-if="$moonpull.currentUserHasAccessTo('appAssociations') && audit.siteAppAssociations" )
        span( v-if="audit.siteAppAssociations.appleAppSiteAssociation" class="badge badge-secondary" )
          | Apple Site App Assoc. Found
        span( v-if="audit.siteAppAssociations.androidAppSiteAssociation" class="badge badge-secondary" )
          | Android Site App Assoc. Found

</template>

<style lang="scss" scoped>
.flex-wrap {
  span.badge {
    margin-right: 10px;
  }
}
</style>

<script>
import Vue from 'vue'
import { isUnsupportedNetwork } from '@/unsupported-networks'
export default Vue.extend({
  
  props: {
    audit: Object,
    column: Boolean,
    wrap: Boolean,
    center: Boolean,
  },
  
  computed: {

    shouldShowGRReasonBadge() {
      return (
        this.audit.manualReviewRequired &&
        this.audit.advertiserSnapshot &&
        this.audit.advertiserSnapshot.cannotAudit &&
        this.audit.advertiserSnapshot.cannotAuditReason &&
        // Only show the badge if audit is GR
        // Or if user is SU
        (
          this.audit.injectedResult ||
          this.$moonpull.currentUserIsSuperAdmin()
        )
      )
    },
  },

  methods: {
    isUnsupportedNetwork,
    
    getCookieStatusAcrossStages() {
      if (! this.audit.moonpullErrors || this.audit.moonpullErrors.length === 0) {
        return 'YY'
      }
      return `${this.audit.moonpullErrors.find(e => e.moonpullErrorId === '5.4') ? 'N' : 'Y'}${this.audit.moonpullErrors.find(e => e.moonpullErrorId === '6.4') ? 'N' : 'Y'}`
    }
  },

})
</script>